var _rect, _rect2, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComingsoonTele(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 131,
    viewBox: "0 0 135 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 131,
    rx: 10,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 134,
    height: 130,
    rx: 9.5,
    stroke: "#3A3A3A",
    strokeOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 92C82.1355 92 94 80.1355 94 65.5C94 50.8645 82.1355 39 67.5 39C52.8645 39 41 50.8645 41 65.5C41 80.1355 52.8645 92 67.5 92Z",
    fill: "url(#paint0_linear_4872_4877)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8694 66.7963C53.9672 65.0899 57.4253 63.6658 60.6563 62.2343C66.2149 59.8898 71.7956 57.5858 77.4325 55.4408C78.5292 55.0754 80.4999 54.7181 80.6931 56.3434C80.5874 58.644 80.1521 60.9312 79.8535 63.2184C79.0959 68.2481 78.2198 73.2606 77.3659 78.2737C77.0715 79.9434 74.9797 80.808 73.6413 79.7394C70.4246 77.5666 67.1832 75.415 64.0076 73.1919C62.9673 72.1347 63.9321 70.617 64.8609 69.8621C67.5103 67.251 70.3199 65.033 72.8308 62.2871C73.5081 60.6514 71.5069 62.0299 70.8469 62.4523C67.2199 64.9517 63.6817 67.6037 59.8577 69.8003C57.9045 70.8756 55.6279 69.9567 53.6755 69.3567C51.925 68.6319 49.3598 67.9016 50.8692 66.7965L50.8694 66.7963Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4872_4877",
    x1: 76.3355,
    y1: 47.8351,
    x2: 63.0855,
    y2: 78.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingsoonTele);
export default __webpack_public_path__ + "static/media/comingsoon_tele.5ac488f2c1217ba7c134daa2c8c9ff22.svg";
export { ForwardRef as ReactComponent };